<template>
  <div class="quick-pass-page">
    <div class="quick-pass-inner">

      <!-- 海報圖稿（WebP 優先，不支援的瀏覽器退回 PNG） -->
      <picture>
        <source :srcset="posterWebp" type="image/webp" />
        <img
          class="poster"
          :src="posterPng"
          width="1200"
          height="1697"
          alt="快速通 直接走：可綁定信用卡免費停車，出場不必尋找繳費機，停車費自動結清、電子發票自動開立。一秒快速通行、信用卡免費停車、優惠券自動折抵、發票自動開立。掃描 QR 加入台灣聯通 LINE 官方帳號，完成會員資料、付款方式、發票載具、車號四步綁定，之後每次出場開到閘門前直接走。"
        />
      </picture>

      <!-- 目前支援場地 -->
      <section class="support-box" aria-labelledby="support-title">
        <h2 id="support-title" class="support-title">目前支援場地</h2>
        <ul class="support-list">
          <li v-for="lot in supportedLots" :key="lot">{{ lot }}</li>
        </ul>
        <p class="support-note">凡張貼「快速通」標章的場站，綁定後即可直接進出。支援場站將陸續增加。</p>
      </section>

      <!-- 手機使用者無法掃描自己螢幕上的 QR Code，這顆按鈕才是他們的入口 -->
      <a
        class="join-button"
        :href="lineLiffUrl"
        target="_blank"
        rel="noopener noreferrer"
      >
        加入快速通（LINE）
      </a>
      <p class="join-note">將於新視窗開啟 LINE 綁定頁面</p>

    </div>
  </div>
</template>

<script>
// 明確 import 讓 webpack 處理雜湊檔名；srcset 綁定需要真實 URL
import posterWebp from '@/assets/quick-pass-poster.webp';
import posterPng from '@/assets/quick-pass-poster.png';

export default {
  name: 'QuickPassPage',
  data() {
    return {
      posterWebp,
      posterPng,
      // 與海報 QR Code 相同的連結
      lineLiffUrl: 'https://liff.line.me/2010513887-ybkBalsE/setup.html?field=3003',
      supportedLots: ['林森場', '城中場', '衡陽場', '博仁醫院場', '台北慈濟醫院場'],
    };
  },
};
</script>

<style scoped>
.quick-pass-page {
  width: 100%;
  background-color: #f5f5f5;
  padding: 32px 16px 64px;
  box-sizing: border-box;
}

.quick-pass-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.quick-pass-inner picture {
  display: block;
  width: 100%;
}

.poster {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);
}

/* 目前支援場地 */
.support-box {
  text-align: left;
  margin-top: 30px;
  width: 100%;
  box-sizing: border-box;
  padding: 26px 32px;
  border-radius: 12px;
  background-color: #fff100;
  border-left: 8px solid #36696a;
}

.support-title {
  margin: 0 0 16px;
  font-size: 32px;
  font-weight: 700;
  color: #36696a;
}

.support-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}

.support-list li {
  padding: 12px 30px;
  border-radius: 999px;
  background-color: #36696a;
  color: #fff100;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.support-note {
  margin: 18px 0 0;
  font-size: 21px;
  color: #36696a;
}

/* 加入按鈕 */
.join-button {
  margin-top: 30px;
  width: 100%;
  max-width: 640px;
  box-sizing: border-box;
  padding: 22px 28px;
  border-radius: 12px;
  background-color: #36696a;
  color: #ffffff;
  font-size: 28px;
  font-weight: 700;
  text-align: center;
  text-decoration: none;
  letter-spacing: 0.02em;
  transition: background-color 0.2s ease;
}

.join-button:hover {
  background-color: #2a5455;
}

.join-button:focus-visible {
  outline: 3px solid #fff100;
  outline-offset: 3px;
}

.join-note {
  margin: 12px 0 0;
  font-size: 18px;
  color: #6b7885;
}

@media screen and (max-width: 560px) {
  .quick-pass-page {
    padding: 20px 12px 48px;
  }

  .join-button {
    font-size: 17px;
    padding: 15px 20px;
  }

  .support-title {
    font-size: 22px;
  }

  .support-list li {
    font-size: 19px;
    padding: 8px 18px;
  }

  .support-note {
    font-size: 16px;
  }

  .join-note {
    font-size: 15px;
  }
}
</style>
